import { render, staticRenderFns } from "./AwardCard.vue?vue&type=template&id=2fefb4aa"
import script from "./AwardCard.vue?vue&type=script&lang=js"
export * from "./AwardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports